import useTimer from './useTimer';
import { logout } from '../resources/auth';

const HOUR_IN_MILLISECONDS = 360000;

const useInactivityLogout = active => {
  /*
   Inactivity logout is only for laptop/PC and when the user has logged in using username/password
   Otherwise return undefined
   */
  const resetTimer = useTimer(logout, active, HOUR_IN_MILLISECONDS);

  if (!resetTimer && active) {
    logout();
  }

  return resetTimer;
};

export default useInactivityLogout;
